module.exports = __webpack_public_path__ + "prod/1.42.2/img/purchase-no-data.334d3832.png";